@if (mainImage$ | async; as main) {
  @if (thumbnails$ | async; as thumbs) {
    <div class="cx-main-image-group">
      <div class="cx-navigate-image">
        @if (getPreviousProduct(thumbs) | async; as previousProduct) {
          <button
            class="btn btn-link"
            [attr.aria-label]="'productImageZoomDialog.previousSlide' | cxTranslate"
            [attr.title]="'productImageZoomDialog.previousSlide' | cxTranslate"
            (click)="openImage(previousProduct.container)"
            >
            <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
          </button>
        }
      </div>
      <ng-container>
        @if (!isZoomed) {
          <cx-media #defaultImage class="cx-default-image-zoom" [container]="main"> </cx-media>
        }
        @if (isZoomed) {
          <div #zoomContainer class="cx-zoom-container">
            <cx-media
              #zoomedImage
              class="cx-image-zoomed"
              [container]="main"
              (mousemove)="pointerMove($event)"
              (touchmove)="touchMove($event)"
              (touchend)="clearTouch()"
              >
            </cx-media>
          </div>
        }
      </ng-container>
      <div class="cx-navigate-image">
        @if (getNextProduct(thumbs) | async; as nextProduct) {
          <button
            class="btn btn-link"
            [attr.aria-label]="'productImageZoomDialog.nextSlide' | cxTranslate"
            [attr.title]="'productImageZoomDialog.nextSlide' | cxTranslate"
            (click)="openImage(nextProduct.container)"
            >
            <cx-icon [type]="iconType.CARET_RIGHT"></cx-icon>
          </button>
        }
      </div>
    </div>
  }
  <cx-product-image-zoom-thumbnails
    [thumbs$]="thumbnails$"
    [activeThumb]="activeThumb"
    (productImage)="changeImage($event)"
  ></cx-product-image-zoom-thumbnails>
}
